const TimelineTourOptions = ({ openContextMenu }) => (
  {
    options: {
      darkLayerPersistence: true,
    },
    tips: [
      {
        title: 'Timeline view',
        description: `This is the timeline view for your project. The timeline shows the 
          sequence of work in your project, and is automatically generated and kept up to date.`,
        selector: '.app-body',
        x: 50,
        y: 70,
        offx: 0,
        offy: 0,
        position: 'bottom',
        onSelected: false,
      },
      {
        title: 'Timeline header',
        description:
          'The header displays both Sprint time and Calendar time once you’ve kicked off your project.',
        selector: '.ag-header-cell',
        x: 270,
        y: 75,
        offx: 0,
        offy: 0,
        position: 'bottom',
        onSelected: false,
      },
      {
        title: 'Skill bar',
        description: `For each feature, the estimated work is represented 
          as skill bars on the timeline, plotted based on dependencies between skills`,
        selector: '.ag-cell',
        x: 250,
        y: 50,
        offx: 0,
        offy: 0,
        position: 'bottom',
        onSelected: false,
      },
      {
        title: 'Info icons on the bar',
        description:
          'Icons are added to the bar when there are conditions that require attention.',
        selector: '.status-icon',
        x: 50,
        y: 50,
        offx: 0,
        offy: 0,
        position: 'bottom',
        onSelected: false,
      },
      {
        title: 'Context',
        description: `The context menu on the bar shows more detail and 
          allows you to take action on a skill, like manually change status.`,
        selector: '.status-icon',
        x: -650,
        y: 180,
        offx: 0,
        offy: 0,
        position: 'top',
        onSelected: openContextMenu,
      },
    ],
  }
);

export default TimelineTourOptions;
